import "react-tooltip/dist/react-tooltip.css";
import SearchBarTags from "../../../../../components/SearchBarText/SearchBarTags";
import { useLoadUser } from "../../../../../Utils/customHooks/useLoadUser";
import SearchBarText from "../../../../../components/SearchBarText/SearchBarText";
import { useNavigate } from "react-router-dom";
import { useLoadIntegrations } from "../../../../../components/IntegrationsBox/useLoadIntegrations";
import { getPlaceholderText } from "../../../../../Utils/StayUpToDate/RenderComponent";

const SearchbarControls = (props: any) => {
  const {
    username,
    controlsLoading,
    controls,
    refetchControls,
    userLoading,
    userData,
    refetch,
    user_id,
  } = props;

  const { data: integrationData } = useLoadIntegrations(user_id as string);

  // Check for connected content platforms
  const hasConnectedContentPlatform =
    integrationData &&
    (Boolean(
      integrationData.instagram_username && integrationData.show_instagram
    ) ||
      Boolean(
        integrationData.youtube_channel_id && integrationData.show_youtube
      ) ||
      Boolean(integrationData.tiktok_user && integrationData.show_tiktok) ||
      Boolean(integrationData.twitter_user && integrationData.show_twitter) ||
      Boolean(integrationData.linkedin_user && integrationData.show_linkedin) ||
      Boolean(integrationData.podcast_link && integrationData.show_podcast) ||
      Boolean(
        integrationData.newsletter_email && integrationData.show_newsletter
      ));

  const hasConnectedAffiliatePlatform =
    integrationData &&
    (Boolean(integrationData.social_amazon && integrationData.show_amazon) ||
      Boolean(integrationData.social_shopmy && integrationData.show_shopmy) ||
      Boolean(integrationData.social_ltk && integrationData.show_ltk));

  // Determine placeholder text based on connected platforms

  return (
    <div className="controls-container">
      <div className="row">
        <div className="controls">
          <div className="account-values-profiles">
            <SearchBarText
              isLoading={userLoading}
              userData={userData}
              refetch={refetch}
              searchBarText={
                userData?.search_bar_text
                  ? userData?.search_bar_text
                  : getPlaceholderText(userData?.name,hasConnectedContentPlatform,hasConnectedAffiliatePlatform)
              }
              username={username}
              user_id={user_id}
              controls={controls}
              refetchControls={refetchControls}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchbarControls;
